import EntryAmount from './EntryAmount';

export default EntryAmount;
